import { useCallback, useMemo, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";

import useUiuxStore from "src/store/useUiuxStore";
import { defaultWMS1101_R01Filter, useWMS1101_R01Store } from "src/containers/mes/WMS/WMS1101_R01/Store_WMS1101_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import LabelPrintButton from "src/components/common/LabelPrintButton";
import { useItemQzPrint } from "src/hooks/useItemQzPrint";
import { WMS1101_R01_buildItemLabelDataListFromSelectedDetails } from "./labelDataBuilder_WMS1101_R01";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_WMS1101_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;
	const {
		WMS1101_R01Filter,
		setWMS1101_R01Filter,
		selectedWMS1101_R01,
		selectedWMS1101_R01DetailList,
		WMS1101_R01DetailList,
	} = useWMS1101_R01Store();

	const { printBulkItemLabel } = useItemQzPrint();

	// 선택된 입고 상세(품목) 행 → 품목코드 라벨 출력용 데이터 (WMS1100 LOT 선택 패턴과 동일)
	const selectedItemLabelDataList = useMemo(() => {
		if (!selectedWMS1101_R01 || selectedWMS1101_R01DetailList.length === 0 || WMS1101_R01DetailList.length === 0) {
			return [];
		}
		return WMS1101_R01_buildItemLabelDataListFromSelectedDetails(
			selectedWMS1101_R01DetailList,
			WMS1101_R01DetailList,
			selectedWMS1101_R01,
		);
	}, [selectedWMS1101_R01, selectedWMS1101_R01DetailList, WMS1101_R01DetailList]);

	const handleLabelPrint = useCallback(async () => {
		if (selectedItemLabelDataList.length === 0) return;
		await printBulkItemLabel(selectedItemLabelDataList);
	}, [selectedItemLabelDataList, printBulkItemLabel]);

    const { setCodeSearchModalProps } = useUiuxStore();

    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: WMS1101_R01Filter.customCd || '',
				customNm: WMS1101_R01Filter.customNm || '',
			}),
		},		
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS1101_R01Filter,
		setEditData: setWMS1101_R01Filter,
		defaultData: defaultWMS1101_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1101_R01_search'
	});

    return (
		<>
		<SearchSectionForm>
			<SearchDateRangeForm
				label="입고 조회 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={WMS1101_R01Filter.dateRange}		setDateRange={(dateRange) => setWMS1101_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min	-w-[80px]",
				}}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={WMS1101_R01Filter.customCd}
				valueLabel={WMS1101_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>

			<LabelPrintButton
				disabled={selectedItemLabelDataList.length === 0}
				buttonText="라벨 출력"
				onPrint={handleLabelPrint}
			/>
		</SearchSectionForm>
		</>
	)
}

export default SearchSection_WMS1101_R01;
